import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const imageDefaultBlocks: BlockNode[] = [
  {
    id: 'img-main',
    type: 'image',
    content: { type: 'image', src: '', alt: '', objectFit: 'cover' },
    layout: { order: 0, widthPct: 100 },
  },
  {
    id: 'img-caption',
    type: 'text',
    content: { type: 'text', value: '', fontSize: 14, color: '#6b7280', textAlign: 'center' },
    layout: { order: 1, widthPct: 100 },
  },
];

export const imageWidget = defineWidget({
  type: 'image',
  schema: {
    label: 'Image',
    description: 'Single image with optional caption and link',
    props: {
      objectFit: {
        type: 'enum',
        label: 'Object Fit',
        options: ['cover', 'contain', 'fill', 'none'],
        default: 'cover',
      },
      aspectRatio: {
        type: 'enum',
        label: 'Aspect Ratio',
        options: ['auto', '1:1', '4:3', '16:9', '3:2', '2:1'],
        default: 'auto',
      },
      linkHref: {
        type: 'link',
        label: 'Link URL',
      },
    },
    slots: {
      image: { type: 'image', label: 'Image' },
      caption: { type: 'text', label: 'Caption' },
    },
    dataDeps: [],
  },
  nameTh: 'รูปภาพ',
  descriptionTh: 'รูปภาพพร้อมคำบรรยายและลิงก์',
  category: 'content',
  thumbnail: '/widget-thumbnails/image.svg',
  defaults: {
    type: 'image',
    props: { objectFit: 'cover', aspectRatio: 'auto' },
    slots: {
      image: { value: '' },
      caption: { value: '' },
    },
  },
  defaultBlocks: imageDefaultBlocks,
});
